import { BookingModel } from "../../entities/booking/BookingModel";
import { BaseODataRepository } from "../BaseODataRepository";

export class BookingODataRepo extends BaseODataRepository<BookingModel> {
  protected baseUrl = `/OData/bookings`;
}
